import React, { useState } from "react";
import "./add-discount-modal.css";
import { ClipLoader } from "react-spinners";
import { showToast } from "../toasts/ToastNotification";
import { createNewEmailForAdmin } from "../../api/gmail.api";

const AddEmailModal = ({ isOpen, onClose, message, title, setEmails }) => {
  const [loading, setLoading] = useState(false);
  if (!isOpen) return null;

  const handleAddEmail = async () => {
    setLoading(true);
    try {
      const res = await createNewEmailForAdmin();

      if (res.success) {
        const newEmail = res.data.newEmail;
        showToast("Thêm email thành công", "success");
          setEmails((prev) => [
              newEmail,
              ...prev
        ]);
        onClose();
      }
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-discount-modal-overlay">
      <div className="admin-discount-modal">
        <div className="admin-discount-modal-head">
        <h2 className="admin-discount-modal-title">{title}</h2>
        <p className="admin-discount-modal-message">
          {message || "Are you sure you want to proceed?"}
        </p>
        </div>
        <div className="admin-discount-modal-actions">
          <button
            disabled={loading}
            className="admin-discount-modal-btn admin-discount-modal-btn-ghost"
            onClick={onClose}
          >
            Hủy
          </button>
          <button
            onClick={handleAddEmail}
            disabled={loading}
            className="admin-discount-modal-btn admin-discount-modal-btn-primary"
          >
            {loading ? <ClipLoader size={20} color="#fff" /> : "Thêm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEmailModal;
